import Modal from 'antd/es/modal/Modal'
import IdeyaTypography from './ideya-typography.tsx'
import Divider from 'antd/es/divider'
import React from 'react'
import { IdeyaButton } from './ideya-button.tsx'

interface IdeyaModalProps extends React.ComponentProps<typeof Modal> {
  isForm?: boolean
  children?: React.ReactNode
}

const IdeyaModal: React.FC<IdeyaModalProps> = (props) => {
  const { isForm = false, children, ...modalProps } = props

  return (
    <Modal
      destroyOnClose={true}
      keyboard={true}
      title={
        <>
          <IdeyaTypography.Text size={'lg'}>{props.title}</IdeyaTypography.Text>
          <Divider />
        </>
      }
      maskClosable={false}
      footer={
        !isForm && (
          <>
            <IdeyaButton ideyaType={'secondary'} onClick={props.onCancel}>
              Cancel
            </IdeyaButton>
            <IdeyaButton onClick={props.onOk}>OK</IdeyaButton>
          </>
        )
      }
      {...modalProps}
    >
      {children}
    </Modal>
  )
}

export default IdeyaModal
